import { useContextState } from '@/hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
    },
    badge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px 12px',
      borderRadius: '12px',
      backgroundColor: colors.color14,
    },
    badgeText: {
      fontSize: '13px',
      fontWeight: '500',
      color: colors.color1,
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      margin: 0,
      padding: 0,
      width: '100%',
    },
    item: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: '10px',
      '&:last-of-type': {
        paddingBottom: '5px',
      },
    },
    bullet: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: colors.color1,
    },
    path: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '6px',
      flex: 1,
    },
    nodeWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    firstNode: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color22,
    },
    node: {
      fontSize: '14px',
      fontWeight: '400',
      color: colors.color22,
    },
    separator: {
      fontSize: '14px',
      fontWeight: '400',
      color: colors.color13,
    },
    showMoreButton: {
      alignSelf: 'flex-start',
      background: 'none',
      border: 'none',
      padding: '0 4px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      color: colors.color1,
    },
  }
}

export { useStyles }
